








































import Vue from "vue";
import Component from "vue-class-component";
import { MedicalInvoice } from "@/components/medicalTransmissionEdit/types";
import NumberInput from "@/components/common/NumberInput.vue";
import { Prop, Emit } from "vue-property-decorator";

@Component({
  components: {
    NumberInput
  }
})
export default class Burden extends Vue {
  @Prop() tab!: MedicalInvoice;

  get BurdenRate() {
    return this.tab.burden_rate;
  }

  set BurdenRate(newValue: number) {
    this.tab.burden_rate = newValue;
    this.updateTotalIns();
  }

  get IsSelfBurden() {
    return this.tab.is_self_burden;
  }

  set IsSelfBurden(newValue: boolean) {
    this.tab.is_self_burden = newValue;
    this.updateTotalIns();
  }

  get SelfBurden() {
    return this.tab.self_burden!!;
  }

  set SelfBurden(newValue: number) {
    this.tab.self_burden = newValue;
    this.updateTotalIns();
  }

  @Emit("updateTotalIns")
  private updateTotalIns() {
    return;
  }
}
